class UValueCalculator {

    constructor() {
    //    this.unit = unit;//foot or meter
    }

    CalculateUValue(doortype, widthmm, heightmm, windows){
        let FAM = doortype;
        if(FAM == 'OH1042S'){
            FAM = 'OH1042P';
        }
        let DLW = widthmm;
        let DLH = heightmm;
        let WINSECT = windows;
        let TWIN = 'None';
        if(windows > 0 && FAM == 'OH1082P'){
            TWIN = 'QARP';
        }else if(windows > 0){
            TWIN = 'DARP';
        }
        
        //QARP
        let WGLASSWINDOW = 552;  //width of the window hole in the panel in mm;
        let HGLASSWINDOW = 247;  //height of the window hole in the panel in mm;
        let WINAREA = (WGLASSWINDOW / 1000) * (HGLASSWINDOW / 1000); //'area of window hole in m2;
        let WINEDGE = ((2 * WGLASSWINDOW) + (2 * HGLASSWINDOW)) / 1000; //'Circomference of one window in m;

        if(TWIN == "DARP"){
            WGLASSWINDOW = 650;  //width of the window hole in the panel in mm
            HGLASSWINDOW = 340;  //height of the window hole in the panel in mm
            WINAREA = 0.179; //area of window hole in m2, currently a fixed value in the calcuation, better would be (wglasswindow / 1000) * (hglasswindow / 1000)
            WINEDGE = 0; 
        }

        this._log("WINAREA = " + WINAREA);

        //calcntotwin;
        let NPANES = this._calcNPanes(DLW);
        let NTOTWIN = NPANES * WINSECT;
        let windowarea = NTOTWIN * WINAREA;
        

        let TTOPSEAL;
        let HTOPSEAL;

        let SOLT = 25;//todo
        let HBOTSECT = 594;
        let HMIDSECT = 545;
        let UTB = 0.01;

        if( DLW < 6050 ){
            TTOPSEAL = "T17";
            HTOPSEAL = 0;
        }else{
            TTOPSEAL = "A65"
            HTOPSEAL = 15;
        }

        //calcntotsect
        let NTOTSECT;
        if((DLW + SOLT - HBOTSECT - HTOPSEAL) % HMIDSECT < 273){
            NTOTSECT = parseInt((DLH + SOLT - HBOTSECT - HTOPSEAL) / HMIDSECT) + 1;
        }else if( (DLW + SOLT - HBOTSECT - HTOPSEAL) % HMIDSECT >= 273){
            NTOTSECT = parseInt((DLH + SOLT - HBOTSECT - HTOPSEAL) / HMIDSECT) + 2;
        }

        //calchtopsect
        let HTOPSECT = 0;
        if(DLH + SOLT - ((NTOTSECT - 2) * HMIDSECT) - HBOTSECT - HTOPSEAL >= 273 && DLH + SOLT - ((NTOTSECT - 2) * HMIDSECT) - HBOTSECT - HTOPSEAL < 541){
            HTOPSECT = DLH + SOLT - ((NTOTSECT - 2) * HMIDSECT) - HBOTSECT - HTOPSEAL;
        }else if( DLH + SOLT - ((NTOTSECT - 2) * HMIDSECT) - HBOTSECT - HTOPSEAL >= 541 && DLH + SOLT - ((NTOTSECT - 2) * HMIDSECT) - HBOTSECT - HTOPSEAL <= 576 ){
            HTOPSECT = 576;
        }else if( DLH + SOLT - ((NTOTSECT - 2) * HMIDSECT) - HBOTSECT - HTOPSEAL >= 576 && DLH + SOLT - ((NTOTSECT - 2) * HMIDSECT) - HBOTSECT - HTOPSEAL <= 817){
            HTOPSECT = DLH + SOLT - ((NTOTSECT - 2) * HMIDSECT) - HBOTSECT - HTOPSEAL;
        }

        //calcdrh
        let DRH = HBOTSECT + ((NTOTSECT - 2) * HMIDSECT) + HTOPSECT + HTOPSEAL;

        //calcoverlaph
        let OVERLAPH = DRH - DLH - HTOPSEAL;
        let overlapherror = 0;
                
        //'OVERLAPH can be between 25 and 60.
        //'it can be played with in order to prevent a high aluminum top profile
        if( OVERLAPH < 25 ){
            overlapherror = OVERLAPH - 25
        }else if( OVERLAPH > 60 ){
            overlapherror = OVERLAPH - 60
        }

        if( overlapherror != 0){
            SOLT = SOLT - overlapherror
            //Call config //todo
        }
        
        //calctopsect
        let TPANELTOPSECT;
        if(HTOPSECT < 507){
            TPANELTOPSECT = "P1";
        }else if(HTOPSECT >= 507 && HTOPSECT <= 563 ){
            TPANELTOPSECT = "P2";
        }else if( HTOPSECT >= 576 && HTOPSECT <= 594 ){
            TPANELTOPSECT = "P3";
        }else if( HTOPSECT >= 595 && HTOPSECT <= 684 ){
            TPANELTOPSECT = "P4";
        }else if( HTOPSECT > 684 ){
            TPANELTOPSECT = "P5";
        }
        
        let PANELAREA = (DLW / 1000) * (DLH / 1000) - windowarea;
        this._log("PANELAREA = " + PANELAREA);
        this._log("FAM = " + FAM);
        
        //Losses through the door;
        //loss through panel in [W/K];
        let LOSSPANELS = PANELAREA * this._calcUValue("panel" + FAM);
        this._log("loss through panel area = " + LOSSPANELS);
        
        //loss through topseal in [W/K];
        let LOSSTOPSEAL = (DLW / 1000) * this._calcPsiValue(TTOPSEAL + FAM, TPANELTOPSECT);
        this._log("loss through topseal = " + LOSSTOPSEAL);
        
        //loss through section joints in [W/K];
        let lossjointseal = 0;
        for(let i=1; i<=NTOTSECT; i++){
            lossjointseal = lossjointseal + ((DLW / 1000) * this._calcPsiValue("panelpanel" + FAM));
        }
        this._log("loss through jointseals = " + lossjointseal);
        
        //loss through bottom seal;
        let LOSSBOTSEAL = (DLW / 1000) * this._calcPsiValue("botseal" + FAM);
        this._log("loss through botseal = " + LOSSBOTSEAL);
        
        //loss through sideseal;
        let LOSSSIDESEAL = 2 * (DLH / 1000) * this._calcPsiValue("sideseal" + FAM);
        this._log("loss through sideseal = " + LOSSSIDESEAL);
        
        //loss through windows in [W/K];
        let losswindows = windowarea * this._calcUValue(TWIN);
        this._log("loss through window area = " + losswindows);
        
        //loss throught window edges in [W/K];
        let losswinedge = NTOTWIN * WINEDGE * this._calcPsiValue(TWIN + "edge");
        this._log("loss through window edge = " + losswinedge);
        
        //loss throught 3D thermal bridges in [W/K];
        let LOSSTB = ((DLW / 1000) * (DLH / 1000)) * UTB;
        this._log("loss through 3D thermal bridges = " + LOSSTB);
        
        //total loss in [W/K];
        let totalloss = LOSSPANELS + LOSSTOPSEAL + lossjointseal + LOSSBOTSEAL + LOSSSIDESEAL + losswindows + losswinedge + LOSSTB;

        //console.log("LOSSPANELS - " + LOSSPANELS + " ,LOSSTOPSEAL - " + LOSSTOPSEAL + ", lossjointseal - " + lossjointseal + ", LOSSBOTSEAL - " + LOSSBOTSEAL + ", LOSSSIDESEAL - " + LOSSSIDESEAL + ", losswindows - " + losswindows + ", losswinedge - " + losswinedge + ", LOSSTB -"  + LOSSTB);
        
        this._log("total loss = " + totalloss);

        //U-value;
        let uvaluedoor = totalloss / ((DLW / 1000) * (DLH / 1000));
        //format u-value as per norm;
        //if(uvaluedoor >== 1 ){
        //    uvaluedoor = Format(uvaluedoor, "0.0");
        //}else{
        //    uvaluedoor = Format(uvaluedoor, "0.00");
        //}
        //frm_main.txt_logout.Text = frm_main.txt_logout.Text + vbNewLine + "U-VALUE = " + uvaluedoor;
        //frm_main.lbl_uvalueout = uvaluedoor;
        //frm_main.txt_logout.Text = frm_main.txt_logout.Text + vbNewLine + "u-value calculation completed" + vbNewLine;

        if(uvaluedoor > 1){
            return parseFloat(uvaluedoor).toFixed(1);
        }else{
            return parseFloat(uvaluedoor).toFixed(2);
        }

    }

    VerifyUValue(){
        console.log('0.47 == ' + this.CalculateUValue('OH1082P',5000,4000,0) );
        console.log('0.78 == ' + this.CalculateUValue('OH1082P',3000,2500,2) );
        console.log('0.68 == ' + this.CalculateUValue('OH1082P',3000,2500,1) );

        console.log('1.3 == ' + this.CalculateUValue('OH1042P',4000,3500,2) );
        console.log('1.1 == ' + this.CalculateUValue('OH1042P',5000,3000,0) );
        console.log('1.1 == ' + this.CalculateUValue('OH1042P',5000,5000,1) );

        console.log('1.2 == ' + this.CalculateUValue('OH1042S',4000,4000,1) );
        console.log('1.1 == ' + this.CalculateUValue('OH1042S',4000,3000,0) );
        console.log('1.3 == ' + this.CalculateUValue('OH1042S',3500,3000,2) );
    }


    GetRefValue(heighmm, widthmm){

        var hIndex = parseInt(heighmm / 500) - 4;
        var wIndex = parseInt(widthmm / 500) - 4;
        if(hIndex < 0){
            hIndex = 0;
        }else if(hIndex > 8){
            hIndex = 8;
        }

        if(wIndex < 0){
            wIndex = 0;
        }else if(wIndex > 12){
            wIndex = 12;
        }

        var refVals = [
            //2000,2500,3000,3500,4000,4500,5000,5500,6000,6500,7000,7500,8000 width
            [5.79,5.79,5.78,5.78,5.78,5.78,5.78,5.78,5.78,5.79,5.78,5.79,5.78],//2000 height
            [5.78,5.78,5.77,5.78,5.77,5.77,5.77,5.77,5.78,5.78,5.78,5.78,5.78],//2500 height
            [5.76,5.76,5.75,5.76,5.75,5.75,5.75,5.75,5.76,5.76,5.76,5.76,5.76],//3000 height
            [5.76,5.75,5.75,5.75,5.75,5.75,5.75,5.75,5.75,5.76,5.75,5.76,5.75],//3500 height
            [5.76,5.75,5.75,5.75,5.75,5.75,5.75,5.75,5.75,5.76,5.75,5.75,5.75],//4000 height
            [5.76,5.75,5.75,5.75,5.75,5.74,5.75,5.75,5.75,5.75,5.75,5.75,5.75],//4500 height
            [5.75,5.74,5.74,5.74,5.74,5.74,5.74,5.75,5.74,5.74,5.74,5.74,5.74],//5000 height
            [5.75,5.74,5.74,5.74,5.74,5.74,5.74,5.74,5.74,5.74,5.74,5.74,5.74],//5500 height
            [5.75,5.74,5.74,5.74,5.74,5.74,5.74,5.74,5.74,5.74,5.74,5.74,5.74],//6000 height
        ]

        return refVals[hIndex][wIndex];

    }

    _log(str){
        //console.log(str);
    }

    _calcNPanes (DLW){
        let NPANES = 0;
        if(DLW >= 2000 && DLW <= 2134 ){
            NPANES = 1;
        }else if (DLW >= 2135 && DLW <= 2999){
            NPANES = 2;
        }else if (DLW >= 3000 && DLW <= 3864){
            NPANES = 3;
        }else if (DLW >= 3865 && DLW <= 4729){
            NPANES = 4;
        }else if (DLW >= 4730 && DLW <= 5594){
            NPANES = 5;
        }else if (DLW >= 5595 && DLW <= 6459){
            NPANES = 6;
        }else if (DLW >= 6460 && DLW <= 7324){
            NPANES = 7;
        }else if (DLW >= 7325 && DLW <= 8189){
            NPANES = 8;
        }else if (DLW >= 8190 && DLW <= 9054){
            NPANES = 9;
        }else if (DLW >= 9055 && DLW <= 10000){
            NPANES = 10;
        }
        return NPANES;
    }

    _calcUValue(item,item2){
        let uvalue = 0;
        //uvalues in W/(m2·K)
        //panels
        if(item == "panelOH1042P" || item == "panelOH1042S"){
            uvalue = 0.81;
        }else if( item == "panelOH1082P" ){
            uvalue = 0.266;
        //windows
        }else if( item == "QARP" ){
            uvalue = 1.33;
        }else if( item == "DARP" ){
            uvalue = 2.7;
        //3D thermal bridges
        }else if( item == "UTBOH1082P" ){
            uvalue = 0.01;
        }else if( item == "UTBOH1042P" ){
            uvalue = 0;
        }
        return uvalue;
    }


    _calcPsiValue(item, item2){
        let psivalue = 0;

        if( item == "panelpanelOH1082P" ){
            psivalue = 0.014;
        }else if( item == "panelpanelOH1042P" ){
            psivalue = 0; //in the current calculation the paneljoint loss is included in the u-value of the panel for the OH1042
        //topseal
        }else if(item == "T17OH1042P" ){
            psivalue = 0.161;
        }else if(item == "T17OH1082P" ){
            if(item2 == "P1" ){
                psivalue = 0.139;
            }else if( item2 == "P2" ){
                psivalue = 0.46;
            }else if( item2 == "P3" ){
                psivalue = 0.405;
            }else if( item2 == "P4" ){
                psivalue = 0.139;
            }else if( item2 == "P5" ){
                psivalue = 0.139;
            }
        }else if( item == "A65OH1042P" ){
            psivalue = 0.161; //configuration is not included in OH1042 calculation, so same psi value used as normal OH1042 top section
        }else if( item == "A65OH1082P" ){
            if(item2 == "P3" ){
                psivalue = 0.687;
            }else{
                psivalue = 0.726;
            }
        //bottomseal
        }else if( item == "botsealOH1042P" ){
            psivalue = 0.178;
        }else if( item == "botsealOH1082P" ){
            psivalue = 0.086;
        //sideseal
        }else if( item == "sidesealOH1042P" ){
            psivalue = 0.366;
        }else if( item == "sidesealOH1082P" ){
            psivalue = 0.28;
        //windowedge
        }else if( item == "DARPedge" ){
            psivalue = 0 //this has never been taken into account for the OH1042
        }else if( item == "QARPedge" ){
            psivalue = 0.073;
        }
        return psivalue;
    }
}

export { UValueCalculator };


// WEBPACK FOOTER //
// ./src/assets/scripts/calculators/uvalue-calculator.js